<template>
    <div class="landDetail">
        <leftnav class="fl" mkcode="A" :itemcode="yj_itemcode"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox py-4">
                    <div class="landThreadToggle-btn" v-if="matchDetail.pushStatus == 0"><el-button class="fr mr-4" :type="baseinfo.thread?'danger':'primary'" @click="landThreadToggle(baseinfo,'land')">{{ baseinfo.thread?'移除':'加入' }}线索管理</el-button></div>
                    <div class="landThreadToggle-btn" v-else><el-button :disabled="true" class="fr mr-4" type="info">已推送单位：{{matchDetail.pushCompanyName}}</el-button></div>
                    <div style="height: auto; padding-bottom: 40px">
                        <table cellspacing="0" cellpadding="4" border="0" class="detail_table  margin-x-auto" width="90%">
                            <tr v-show="pageType == 2">
                                <!-- <td class="thead font-bold" colspan="1">复合筛选条件数</td>
                                <td class="thead" colspan="1"><el-rate :disabled="true" :colors="['#333','#333','#333']" v-model="baseinfo.monitor.star"></el-rate></td> -->
                                <td class="thead font-bold" colspan="2">
                                    筛选条件
                                    <p class="mt-1"><i class="el-icon-star-on font-20" v-for="(item, index) in baseinfo.monitor.star" :key="index"></i></p>
                                </td>
                                <td class="thead" colspan="5">
                                   <div class="text-left rate-detail">
                                     <p :class="baseinfo.monitor.detail.size?'font-bold':'gray-font'"> <i class="el-icon-star-on font-20"></i> 土地面积高于最低监测标准；</p>
                                     <p :class="baseinfo.monitor.detail.keyword?'font-bold':'gray-font'"> <i class="el-icon-star-on font-20"></i> 项目名称含重点行业关键词；</p>
                                     <p :class="baseinfo.monitor.detail.industry?'font-bold':'gray-font'"> <i class="el-icon-star-on font-20"></i> 行业分类属于重点行业范围；</p>
                                     <p :class="baseinfo.monitor.detail.enterprise?'font-bold':'gray-font'"> <i class="el-icon-star-on font-20"></i> 投资方属于重点企业；</p>
                                     <p :class="baseinfo.monitor.detail.city?'font-bold':'gray-font'"> <i class="el-icon-star-on font-20"></i> 项目地点属于百城范围；</p>
                                     
                                   </div>
                                </td>
                            </tr>
                            <tr v-if="pageType == 3">
                                <td class="thead font-bold" colspan="2">线索分析</td>
                                <td class="thead" colspan="3">
                                    <div id="anlyse-charts"></div>
                                </td>
                                <td class="thead" colspan="2">
                                     <div class="line-height36 font-bold">
                                        <p>总得分：{{ analyse.total }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                        <p>评级：
                                            <span v-if="analyse.total >= 9">A+ - 特别关注</span>
                                            <span v-if="analyse.total >= 7.5 && analyse.total < 9">A - 重点关注</span>
                                            <span v-if="analyse.total >= 6 && analyse.total < 7.5">B - 中等关注</span>
                                            <span v-if="analyse.total >= 4 && analyse.total < 6">C - 简单关注</span>
                                            <span v-if="analyse.total < 4">D - 可以忽略</span>
                                            <el-tooltip class="item smartTip-text" effect="light"
												placement="right-start">
												<i class="el-icon-question"
													style="color:cornflowerblue;margin-left: 5px;"></i>
												<div slot="content" class="list_tips">
                                                    <p class="list_tips_p">1-4分&nbsp;&nbsp;&nbsp;：D级，可以忽略</p>
                                                    <p class="list_tips_p">5-6分&nbsp;&nbsp;&nbsp;：C级，简单关注</p>
                                                    <p class="list_tips_p">7-8.5分：B级，中等关注</p>
                                                    <p class="list_tips_p">8.5-9分：A级，重点关注</p>
                                                    <p class="list_tips_p">9分以上：A+级，特别关注</p>
												</div>
											</el-tooltip>
                                        </p>
                                     </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="thead font-bold" colspan="7">供地结果信息</th>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目名称:</td>
                                <td class="cols3" colspan="6">
                                    {{ baseinfo.projectName }}
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目位置:</td>
                                <td class="cols3" colspan="6">
                                    {{ baseinfo.location }}
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目城市:</td>
                                <td class="col2" colspan="3">
                                    {{ baseinfo.area }}
                                </td>
                                <td class="col3 font-bold">电子监管号：</td>
                                <td class="col4" colspan="2">{{ baseinfo.ecNumber }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">批准单位:</td>
                                <td class="col2" colspan="3">{{ baseinfo.approver }}</td>
                                <td class="col3 font-bold">合同签订日期:</td>
                                <td class="col4" colspan="2">{{ baseinfo.time || '-' }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">土地使用权人:</td>
                                <td class="cols3" colspan="3">{{ baseinfo.owner }}</td>
                                <td class="col1 font-bold">投资主体:</td>
                                <td class="cols3" colspan="2">{{ baseinfo.sourceEnterprise || '-' }}</td>
                                
                            </tr>
                            <tr>
                                <td class="col1 font-bold">土地用途:</td>
                                <td class="col2" colspan="3">{{ baseinfo.purpose }}</td>
                                <td class="col1 font-bold">土地使用年限:</td>
                                <td class="col2" colspan="2">{{ baseinfo.useYears }}</td>
                            </tr>
                            <tr>
                                <td class="col3 font-bold">行业分类:</td>
                                <td class="col4" colspan="3">
                                    {{ baseinfo.industry }}
                                </td>
                                <td class="col1 font-bold">土地级别:</td>
                                <td class="col2" colspan="2">{{ baseinfo.level }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">面积(亩<!--公顷-->):</td>
                                <td class="col2" colspan="3">{{ baseinfo.size.toFixed(2) }}</td>
                                <td class="col3 font-bold">成交价格(万元):</td>
                                <td class="col4" colspan="2">{{ baseinfo.amount }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">约定容积率:</td>
                                <td class="font-bold">下限:</td>
                                <td>{{ baseinfo.volumeLower || '-' }}</td>
                                <td class="font-bold">上限:</td>
                                <td>{{ baseinfo.volumeUpper }}</td> 
                                <td class="col3 font-bold">供地方式:</td>
                                <td class="col4">
                                    {{ baseinfo.supplyMode }}
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">分期支付约定:</td>
                                <td class="cols3" colspan="6" style="margin: 0;padding: 0;">
                                    <table cellspacing="0" cellpadding="2" border="0" class="paytable" width="100%">
                                        <tr>
                                            <td class="pcol1 font-bold">支付期号</td>
                                            <td class="pcol2 font-bold">约定支付日期</td>
                                            <td class="pcol3 font-bold">约定支付金额(万元)</td>
                                            <td class="pcol4 font-bold">备注</td>
                                        </tr>
                                        <tr v-for="(payment, i) in baseinfo.payments" :key="i">
                                            <td class="pcol1">{{ payment.number }}</td>
                                            <td class="pcol2">{{ payment.time }}</td>
                                            <td class="pcol3">{{ payment.money }}{{ payment.unit }}</td>
                                            <td>{{ payment.remark }}</td>
                                        </tr>
                                    </table>
                                </td>
                                <!-- <td class="col3 font-bold">土地来源:</td>
                                <td class="col4" colspan="2">{{ baseinfo.origin || '-' }}</td> -->
                            </tr>
                            
                            <tr>
                                <td class="col3 font-bold">约定交地时间:</td>
                                <td class="col4" colspan="6">{{ baseinfo.deliveryTime || '-' }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">约定开工时间:</td>
                                <td class="col2" colspan="4">{{ baseinfo.startTime || '-' }}</td>
                                 <td class="col1 font-bold">实际开工时间:</td>
                                <td class="col2">{{ baseinfo.realStartTime || '-' }}</td>
                                
                            </tr>
                            <tr>
                                <td class="col3 font-bold">约定竣工时间:</td>
                                <td class="col4" colspan="4">{{ baseinfo.endTime || '-' }}</td>
                                <td class="col3 font-bold">实际竣工时间:</td>
                                <td class="col4">{{ baseinfo.realEndTime || '-' }}</td>
                            </tr>
                            
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: "landDetail",
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(["isCollapse"]),
    },
    data() {
        return {
            userdata: {},
            yj_itemcode: "A",
            pageType : 1,
            id: "",
            baseinfo: {
                size: 0,
                amount: 0,
                volumeLower: 0,
                volumeUpper: 0,
                payments: [],
                sourceArea: "",
                deliveryTime: "",
                startTime: "",
                endTime: "",
                realStartTime: "",
                realEndTime: "",
                industry: "",
                level: "",

                monitor: {
                    star:0,
                    detail: {
                        money:false,
                        keyword:false,
                        industry:false,
                        enterprise:true,
                        city:false,
                    }
                },
                rate:4,
                province: "河北省",
                city: "唐山市",
                county: "",
                projectName: "海上风电法兰二期项目",
                projectLocation: "装备制造园区宏远路南侧",
                ecNumber: "123456",
                nSizeUnit: "58.98",
                source: "",
                bigLandUse: "工矿仓储用地",
                bigSupplyMode: "拍卖出让",
                smallSupplyMode: "",
                useYears: "50",
                smallIndustry: "金属制品业",
                landLevel: "十二级",
                nPriceUnit: "667",
                paymentList: [
                    { number: "1",
                    payTime: "2025/12/9",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                    { number: "2",
                    payTime: "2026/12/8",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                    { number: "3",
                    payTime: "2027/12/7",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                ],
                landOwner: "唐山文丰重工有限公司",
                volumeUpper: "",
                deliveryTime: "2026/12/8",
                startTime: "2027/12/7",
                endTime: "2029/12/6",
                realStartTime: "",
                realEndTime: "",
                approvalCompany: "曹妃甸区人民政府",
                contractTime: "2025/12/9",
                memo: "",
                volumeLower: "0.8",
                investment: "唐山文丰重工有限公司",
                
                // 其他属性
            },
            analyse: {
                customer: 0,
                area: 0,
                industry: 0,
                landtype: 0,
                scale: 0,
                total: 0,
            },
            matchDetail: {
                pushStatus: 0,
            },
            colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"],
        };
    },
    created() {
        this.pageType = this.$route.query.pageType?this.$route.query.pageType:1;
        this.id = this.$route.query.id;
    },
    mounted() {
        // if (this.pageType == 3) { 
            this.getAnalyseInfo();
        // }else{
            this.getDetailInfo(); //其实==3的时候可以不调这个接口，但是matchDetail只有这个接口才返回
        // }
            
            
    },
    methods: {
        //获取线索分析详情
        getAnalyseInfo() {
            this.$axios.get(this.$api.metall.LandThread.Analyse()+'?id='+this.id).then((res) => {
               if (res.data.success) { 
                console.log('res.data',res);
                this.analyse = res.data.data.analyse;
                this.baseinfo = res.data.data.land;
                // this.matchDetail = res.data.data;
                 this.randerCharts('anlyse-charts',this.analyse);
                document.title =  this.baseinfo.projectName + '-详情页';
               } else {
                //    this.$message.error(res.data.message); 
               }
           })
        },
        getDetailInfo(){
             this.$axios.get(this.$api.metall.LandThread.Match()+'?id='+this.id).then((res) => {
               if (res.data.success) { 
                console.log('res.data.detail',res);
                this.baseinfo = res.data.data.land;
                document.title= this.baseinfo.projectName + '-详情页';
                this.matchDetail = res.data.data;
                this.bus.$emit('loading', false);
               } else {
                //    this.$message.error(res.data.message); 
                this.bus.$emit('loading', false);
               }
           })
        },
        randerCharts(el,data) { 
            console.log('雷达图', data);
			var myChart = echarts.init(document.getElementById(el));
			var option = {
				title: {
					text: ''
				},
				color: this.colors,
				// legend: {
				// 	show: true, bottom: 0, left: 'center',
				// },
				tooltip: { show: true },
				radar: {
					// radius: 150,
					axisName: { fontSize: 14, color: '#666' },
					splitArea: {
						//分割区域的样式	
						areaStyle: { color: ['#fff', '#fff', '#fff', '#fff', '#fff'], opacity: 0.2, }
					},
					// splitLine:{lineStyle:{type:'dashed'}},
					axisLine: { show: true, color: "#eee" },  //设置所有刻度线不显示
					indicator: [{name:"客户维度", max: 10}, {name:"区域维度", max: 10}, {name:"行业维度", max: 10}, {name:"规模维度", max: 10}],
				},
				series: [{
					type: 'radar', label: { show: true },
					data:  [{value:[data.customer,data.area,data.industry,data.scale],name: '线索分析得分'}],
					areaStyle: { normal: { color: this.colors[0], opacity: 0.2, shadowColor: '#000', } },
					lineStyle: { normal: { color: 'blue', width: 2 } },//折线样式
					symbol: "none", // 去掉图表中各个图区域的边框线拐点
				}]
			};
			myChart.setOption(option);
		},
    },
};
</script>
<style lang="scss">
.analysedetail{
    line-height: 28px;
}
.landThreadToggle-btn{
    height: 60px;
    padding-right: 85px;
}
.detail_table {
    border: 1px solid #f2f2f2;
    border-bottom: none;
    background: #fff;
    overflow: hidden;

    th,
    td {
        padding: 0 15px;
        text-align: center;
    }

    th {
        font-size: 16px;
        line-height: 54px;
        height: 54px;
        background: #f2f8fe;
        white-space: nowrap;
    }

    td {
        line-height: 24px;
        border-bottom: 1px solid #eee;
        min-width: 80px;
        font-size: 16px;
        text-align: center;
        padding-top: 8px;
        padding-bottom: 8px;
        max-width: 300px;
        border-right: 1px solid #eee;
        &.font-bold { 
            font-size: 16px;
        }
    }

    tr:hover {
        background: #fcfdff;
    }

    a {
        color: #2a51a4;
    }

    tr td:first-child {
        background: #fcfdff;
    }

    a:hover {
        text-decoration: underline;
        color: #f39800;
    }

    &.table {
        border-top: 1px solid #f2f2f2;
        border-left: 1px solid #f2f2f2;
    }
}

.clueManagement .whitebox {
    min-height: 95vh;
}
.rate-detail{
    line-height: 36px;
}
.gray-font{
    color: #aaa;
}
</style>